import './TableOfContentsEntry.scss';
import { ReactComponent as Checkmark } from 'images/icons/Checkmark.svg';
import { ReactComponent as Padlock } from 'images/icons/PadlockFilled.svg';
import { ReactComponent as Crown } from 'images/icons/Crown.svg';
import { Chip } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';
import { Prerequisite } from 'types/module';
import { useMemo } from 'react';

type TableOfContentsEntryProps = {
  title: string;
  isLocked: boolean;
  isCompleted: boolean;
  isPremiumUser: boolean;
  isSelected?: boolean;
  comingSoon?: boolean;
  type: 'lesson' | 'chapterTest' | 'certificate';
  isInteractive: boolean;
  progress?: number;
  prerequisites?: Prerequisite[];
  handleEntrySelection: () => void;
};

export const TableOfContentsEntry = ({
  title,
  isLocked,
  isCompleted,
  isPremiumUser,
  isSelected,
  comingSoon,
  type,
  isInteractive,
  progress,
  prerequisites,
  handleEntrySelection,
}: TableOfContentsEntryProps) => {
  const { t } = useTranslation();

  const getTableEntryClasses = () => {
    let initialClasses = 'table-entry';
    if (isLocked || comingSoon) {
      initialClasses = `${initialClasses} entry-disabled`;
    }
    if (isSelected) {
      initialClasses = `${initialClasses} entry-selected`;
    }
    if (isInteractive) {
      initialClasses = `${initialClasses} entry-interactive`;
    }
    return initialClasses;
  };

  const entryStatusIcon = useMemo(() => {
    if (isCompleted) {
      return (
        <div className='checkmark-icon' style={{ backgroundColor: type === 'certificate' ? '#ec691a' : '#414141' }}>
          <Checkmark />
        </div>
      );
    } else if (!isPremiumUser && type !== 'lesson') {
      return <Crown className='icon premium-content-icon' />;
    } else if (isLocked) {
      return <Padlock className='icon' />;
    } else {
      return <div className='circle'></div>;
    }
  }, [isCompleted, isPremiumUser, type, isLocked, prerequisites]);

  const badgeLabel = useMemo(() => {
    if (comingSoon) {
      return t('ComingSoon', { ns: 'learningHub' });
    } else if (progress && progress > 0) {
      return t('InProgress', { progress, ns: 'learningHub' });
    } else {
      return '';
    }
  }, [comingSoon, progress, t]);

  return (
    <div className={getTableEntryClasses()} onClick={handleEntrySelection}>
      <div>
        {!comingSoon && <>{entryStatusIcon}</>}
        <span>{title.toLowerCase()}</span>
        {type !== 'lesson' && !comingSoon && isPremiumUser && <Crown className='icon premium-content-icon' />}
      </div>
      {comingSoon || (progress && progress > 0 && progress < 100) ? <Chip label={badgeLabel} className='entry-badge' /> : <></>}
    </div>
  );
};
